import {Button, Modal} from "antd";
import React from "react";
import {connect} from "react-redux";
import {bindActionCreators, Dispatch} from "redux";
import FirebaseService from "../../../core/services/firebaseService/firebase.service";
import {IStore} from "../../../core/utilities/reducers";
import {UI} from "../../../core/utilities/ui";
import FirebaseKey from "../../FirebaseKey/FirebaseKey";
import "./CCSavedRemoveModal.scss";

interface IProps {
  callback: (isApproved: boolean) => void;
}

const CCSavedRemoveModal = (props: IProps) => {

  return (
    <Modal
      className="cc-saved-remove-modal"
      maskStyle={UI.modalMaskStyle()}
      visible
      closable={false}
      footer={false}
      centered
      destroyOnClose
      onCancel={() => props.callback(false)}
    >
      <div className="content">
        <FirebaseKey className="title" firebaseKey={FirebaseService.delete_card_are_you_sure_title}/>
        <FirebaseKey className="text" firebaseKey={FirebaseService.delete_card_are_you_sure_desc}/>
        <div className="buttons">
          <Button
            className="app-button secondary"
            onClick={() => props.callback(false)}
          >
            <FirebaseKey firebaseKey={FirebaseService.delete_card_are_you_sure_button_cancel}/>
          </Button>
          <Button
            className="app-button"
            onClick={() => props.callback(true)}
          >
            <FirebaseKey firebaseKey={FirebaseService.delete_card_are_you_sure_button_delete}/>
          </Button>
        </div>
      </div>
    </Modal>
  );
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators(
    {},
    dispatch
  );
};
const mapStateToProps = (store: IStore) => {
  return {}
};

export default connect(mapStateToProps, mapDispatchToProps)(CCSavedRemoveModal);
